import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ViewEncapsulation,
  booleanAttribute,
  input,
  output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { isRequired } from '../../utilities/form-control.util';

@Component({
  selector: 'procure-input-switch',
  templateUrl: './input-switch.component.html',
  styleUrl: './input-switch.component.scss',
  imports: [MatSlideToggle, MatTooltip, ReactiveFormsModule, NgTemplateOutlet],
  encapsulation: ViewEncapsulation.None,
})
export class InputSwitch {
  readonly valueChange = output<MatSlideToggleChange>();

  readonly id = input<string | null>(null);
  readonly control = input.required<FormControl>();
  readonly tooltip = input<string>('');
  readonly labelPosition = input<'before' | 'after'>('after');

  readonly showMode = input<boolean, boolean | string>(false, {
    transform: booleanAttribute,
  });

  readonly condensed = input<boolean, boolean | string>(false, {
    transform: booleanAttribute,
  });

  protected get isRequired(): boolean {
    return isRequired(this.control());
  }
}
